import React from 'react';
import I18n from '@/modules/i18n';
import AIBadge from '@/components/shared/AIBadge';
import GradeFasterItem from './GradeFasterItem';
import { AIGradingEligibility } from './useAIGrading';

interface SuggestScoresItemProps {
  eligibility: AIGradingEligibility;
  openedWithPointer: boolean;
  starting: boolean;
  onStart: () => void;
}

const SuggestScoresItem = ({
  eligibility, openedWithPointer, starting, onStart,
}: SuggestScoresItemProps) => {
  const disabled = eligibility.eligible_count === 0 || starting;
  const unavailableReason = eligibility.answered_count === 0 ? 'ai_grading_no_answers' : 'ai_grading_all_handled';
  const descriptionKey = eligibility.eligible_count === 0 ? unavailableReason : 'ai_grading_suggest_scores_description';

  return (
    <GradeFasterItem
      description={I18n.t(descriptionKey)}
      disabled={disabled}
      icon="Sparkle"
      iconClassName="tw-size-4"
      openedWithPointer={openedWithPointer}
      title={(
        <>
          {I18n.t('ai_grading_suggest_scores_with')}
          <AIBadge disabled={disabled} />
        </>
      )}
      onSelect={onStart}
    />
  );
};

export default SuggestScoresItem;
